<template>
  <section id="timeline">
    <div class="demo">
      <h5>Basic</h5>
      <ul class="timeline">
        <li class="timeline-item">
          <div class="timeline-info">
            <span class="text-label">March 12, 2016</span>
          </div>
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <h4 class="timeline-title">Event Title</h4>
            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Donec vitae sapien ut libero venenatis faucibus. ullam dictum felis eu pede
              mollis pretium. Pellentesque ut neque.</p>
          </div>
        </li>
        <li class="timeline-item">
          <div class="timeline-info">
            <span class="text-label">March 23, 2016</span>
          </div>
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <h4 class="timeline-title">Event Title</h4>
            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Donec vitae sapien ut libero venenatis faucibus. ullam dictum felis eu pede
              mollis pretium. Pellentesque ut neque.
            </p>
          </div>
        </li>
        <li class="timeline-item">
          <div class="timeline-info">
            <span class="text-label">April 02, 2016</span>
          </div>
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <h4 class="timeline-title">Event Title</h4>
            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Donec vitae sapien ut libero venenatis faucibus. ullam dictum felis eu pede
              mollis pretium. Pellentesque ut neque.
            </p>
          </div>
        </li>
        <li class="timeline-item">
          <div class="timeline-info">
            <span class="text-label">April 28, 2016</span>
          </div>
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <h4 class="timeline-title">Event Title</h4>
            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Donec vitae sapien ut libero venenatis faucibus. ullam dictum felis eu pede
              mollis pretium. Pellentesque ut neque.
            </p>
          </div>
        </li>
      </ul>
      <hr class="sg-hr"/>
      <h5>Split</h5>
      <ul class="timeline timeline-split">
        <li class="timeline-item">
          <div class="timeline-info">
            <span class="text-label">March 12, 2016</span>
          </div>
          <div class="timeline-marker marker-icon">
            <i class="gel-icon-notes" title="Notes"></i>
          </div>
          <div class="timeline-content">
            <h4 class="timeline-title">Event Title</h4>
            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Donec vitae sapien ut libero venenatis faucibus. ullam dictum felis eu pede
              mollis pretium. Pellentesque ut neque.</p>
          </div>
        </li>
        <li class="timeline-item">
          <div class="timeline-info">
            <span class="text-label">March 23, 2016</span>
          </div>
          <div class="timeline-marker marker-icon">
            <i class="gel-icon-user-add" title="Communication"></i>
          </div>
          <div class="timeline-content">
            <h4 class="timeline-title">Event Title</h4>
            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Donec vitae sapien ut libero venenatis faucibus. ullam dictum felis eu pede
              mollis pretium. Pellentesque ut neque.
            </p>
          </div>
        </li>
        <li class="timeline-item">
          <div class="timeline-info">
            <span class="text-label">April 02, 2016</span>
          </div>
          <div class="timeline-marker marker-icon">
            <i class="gel-icon-calendar" title="Interview"></i>
          </div>
          <div class="timeline-content">
            <h4 class="timeline-title">Event Title</h4>
            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Donec vitae sapien ut libero venenatis faucibus. ullam dictum felis eu pede
              mollis pretium. Pellentesque ut neque.
            </p>
          </div>
        </li>
        <li class="timeline-item">
          <div class="timeline-info">
            <span class="text-label">April 28, 2016</span>
          </div>
          <div class="timeline-marker marker-icon">
            <i class="gel-icon-tick" title="Background checked"></i>
          </div>
          <div class="timeline-content">
            <h4 class="timeline-title">Event Title</h4>
            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Donec vitae sapien ut libero venenatis faucibus. ullam dictum felis eu pede
              mollis pretium. Pellentesque ut neque.
            </p>
          </div>
        </li>
        <li class="timeline-item">
          <div class="timeline-info">
            <span class="text-label">April 28, 2016</span>
          </div>
          <div class="timeline-marker marker-icon">
            <i class="gel-icon-envelope" title="Communication"></i>
          </div>
          <div class="timeline-content">
            <h4 class="timeline-title">Event Title</h4>
            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Donec vitae sapien ut libero venenatis faucibus. ullam dictum felis eu pede
              mollis pretium. Pellentesque ut neque.
            </p>
          </div>
        </li>
      </ul>
      <hr class="sg-hr"/>
      <h5>Centered</h5>
      <ul class="timeline timeline-centered">
        <li class="timeline-item">
          <div class="timeline-info">
            <span class="text-label">March 12, 2016</span>
          </div>
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <h4 class="timeline-title">Event Title</h4>
            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Donec vitae sapien ut libero venenatis faucibus. ullam dictum felis eu pede
              mollis pretium. Pellentesque ut neque.</p>
          </div>
        </li>
        <li class="timeline-item">
          <div class="timeline-info">
            <span class="text-label">March 23, 2016</span>
          </div>
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <h4 class="timeline-title">Event Title</h4>
            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Donec vitae sapien ut libero venenatis faucibus. ullam dictum felis eu pede
              mollis pretium. Pellentesque ut neque.
            </p>
          </div>
        </li>
        <li class="timeline-item">
          <div class="timeline-info">
            <span class="text-label">April 02, 2016</span>
          </div>
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <h4 class="timeline-title">Event Title</h4>
            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Donec vitae sapien ut libero venenatis faucibus. ullam dictum felis eu pede
              mollis pretium. Pellentesque ut neque.
            </p>
          </div>
        </li>
        <li class="timeline-item">
          <div class="timeline-info">
            <span class="text-label">April 28, 2016</span>
          </div>
          <div class="timeline-marker"></div>
          <div class="timeline-content">
            <h4 class="timeline-title">Event Title</h4>
            <p>Nullam vel sem. Nullam vel sem. Integer ante arcu, accumsan a, consectetuer eget, posuere ut, mauris. Donec orci lectus, aliquam ut, faucibus non, euismod id, nulla. Donec vitae sapien ut libero venenatis faucibus. ullam dictum felis eu pede
              mollis pretium. Pellentesque ut neque.
            </p>
          </div>
        </li>
      </ul>
    </div>  
        <section class="md" v-html="mdfile"></section>
  </section> 
</template>

<script>
import mdfile from "@/docs/components/timeline.md";
export default {
  name: "timeline",
  beforeCreate: function () {
    this.$emit("update-title", this.$root.yamlData.components.timeline.name);
    this.$emit("update-tagline", this.$root.yamlData.components.timeline.description);
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
